module.exports = __webpack_public_path__ + "static/logo-2e2fb1d5b0376bf3f13ea8e80528d62d.svg";